import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { PermissionModule } from '@/store/modules/permission';
import SidebarItem from './SidebarItem.vue';
import SidebarLogo from './SidebarLogo.vue';
import variables from '@/styles/variables.scss';
let default_1 = class extends Vue {
    get routes() {
        return PermissionModule.routes.filter((route) => !route.meta || route.meta.hidden !== true);
    }
    get sidebar() {
        return AppModule.sidebar;
    }
    get variables() {
        return variables;
    }
    get activeMenu() {
        const route = this.$route;
        const { meta, path } = route;
        // if set path, the sidebar will highlight the path you set
        if (meta && meta.activeMenu) {
            return meta.activeMenu;
        }
        return path;
    }
    get isCollapse() {
        return !this.sidebar.opened;
    }
};
default_1 = tslib_1.__decorate([
    Component({
        name: 'SideBar',
        components: {
            SidebarItem,
            SidebarLogo,
        },
    })
], default_1);
export default default_1;
